import axios from '@/axios'

import authService from '@/services/authentication'
// NOTE: passing url into the functions below allows us to re-use this base service in
// the related more-specific versions.

// NOTE: do NOT mess with what we return on the callback here, we abosultely need to pass in the relationships and the attributes and deal with
// the consequencyes inside the receivers. Otherwise we lose too much meta info
export default {
  index: (cbOk, cbErr, url) => {
    return axios.get(url)
      .then(response => {
        if (response.data) {
          response.data.items = response.data.items.map((item) => { return item.data })
          if (cbOk) cbOk(response.data.items, response.data.total)
        }
      })
      .catch(err => {
        if (err && err.response && err.response.status === 401) {
          authService.logout()
        }
        if (cbErr) cbErr(err)
      })
  },

  show: (cbOk, cbErr, url) => {
    return axios.get(url)
      .then(response => {
        if (response.data) {
          if (cbOk) cbOk(response.data.data)
        }
      })
      .catch(err => {
        if (err.response.status === 401) {
          authService.logout()
        }
        if (cbErr) cbErr(err)
      })
  },

  create: (cbOk, cbErr, instance, url) => {
    return axios.post(url, instance)
      .then(response => {
        if (response.data) {
          if (cbOk) cbOk(response.data.data)
        }
      })
      .catch(err => {
        if (err && err.response && err.response.status && (err.response.status === 401)) {
          authService.logout()
        }
        if (cbErr) cbErr(err)
      })
  },

  // NOTE: we might want to debounce updates so we dont save to the api with every keystroke
  update: (cbOk, cbErr, instance, url) => {
    return axios.put(url, instance)
      .then(response => {
        if (response.data) {
          if (cbOk) cbOk(response.data.data)
        }
      })
      .catch(err => {
        if (err.response.status === 401) {
          authService.logout()
        }
        if (cbErr) cbErr(err)
      })
  },

  delete: (cbOk, cbErr, url) => {
    return axios.delete(url)
      .then(response => {
        if (response.data) {
          // delete typically returns a blank object as data, so we can't dig into it
          if (cbOk) cbOk(response.data)
        }
      })
      .catch(err => {
        if (err.response.status === 401) {
          authService.logout()
        }
        if (cbErr) cbErr(err)
      })
  },

  // Pagination helper
  paginationParams (pagination) {
    if (pagination) {
      let params = [
        `query=${encodeURIComponent(pagination.search)}`,
        `limit=${parseInt(pagination.rowsPerPage)}`,
        `offset=${(parseInt(pagination.page) - 1) * parseInt(pagination.rowsPerPage) || 0}`,
        `sort_by=${pagination.sortBy}`,
        `sort_dir=${pagination.descending ? 'asc' : 'desc'}`
      ]
      return params.join('&')
    } else {
      return ''
    }
  }

}



// WEBPACK FOOTER //
// ./src/services/model.js